<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ "REQUISITOS.LBL_PRODUCTOS" | translate }}</label>
          <p-dropdown disableTab
            id="idRespaldo"
            name="nomRespaldo"
            [options]="lisProductos"
            filter="filter"
            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
            optionLabel="label"
            optionValue="value"
            formControlName="idProducto"
          ></p-dropdown>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idProducto.invalid"
          >
            {{ "REQUISITOS.LBL_PRODUCTOS" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4 pt-5">
        <div class="div-form">
          <button
            icon="fa fa-plus"
            label="{{ 'BTN_AGREGAR' | translate }}"
            type="submit"
            (click)="onSubmit()"
            pButton
          ></button>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6"></div>
    <div class="col-12 md:col-6 lg:col-6">
      <input
        type="text"
        pInputText
        size="40"
        placeholder="{{ 'LBL_BUSCAR' | translate }}"
        (input)="dt.filterGlobal($event.target.value, 'contains')"
      />
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        #dt
        [value]="lisRequisitoProducto"
        [paginator]="true"
        [rows]="10"
        paginatorPosition="bottom"
        [globalFilterFields]="['nombreProducto']"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.nombreProducto }}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_INHABILITAR' | translate }}"
                  pButton
                  (click)="inhablitar(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="producto">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #cdpr key="producto-requisito">
  <p-footer>
    <button type="button" pButton label="{{ 'BTN_ACEPTAR' | translate }}" (click)="cdpr.reject()"></button>
  </p-footer>
</p-confirmDialog>
